import { render, staticRenderFns } from "./CompanyFeedbackDialog.vue?vue&type=template&id=9f54d990&scoped=true&"
import script from "./CompanyFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyFeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "../../../statistics/css/companyV2common.css?vue&type=style&index=0&id=9f54d990&scoped=true&lang=css&"
import style1 from "../../../statistics/css/common.css?vue&type=style&index=1&id=9f54d990&scoped=true&lang=css&"
import style2 from "./CompanyFeedbackDialog.vue?vue&type=style&index=2&id=9f54d990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f54d990",
  null
  
)

export default component.exports